module.exports = __webpack_public_path__ + "media/src/images/partners/passau-f217c2fabae14edf3357c65bd21593e8.jpg";